/*
  Errors in plain words. A refusal from the server already carries the sentence the person reads
  (2.1.4); anything else (a broken connection, a bug) gets one calm sentence instead of a technical message.
*/

import { NetworkError, RefusalError } from "./client";
import type { RefusalCode } from "./types";

export const SOMETHING_WENT_WRONG = "Something went wrong. Please try again.";

export function isRefusal(error: unknown, ...codes: RefusalCode[]): error is RefusalError {
  return error instanceof RefusalError && (codes.length === 0 || codes.includes(error.code));
}

/** The sentence to show a person for an error. */
export function refusalText(error: unknown): string {
  if (error instanceof RefusalError) return error.message;
  if (error instanceof NetworkError) return error.message;
  return SOMETHING_WENT_WRONG;
}

/** True when the session is over or the password must change first: the person has to go through `me` again. */
export function isAuthProblem(error: unknown): boolean {
  return isRefusal(error, "not_signed_in", "must_change_password");
}
